// extracted by mini-css-extract-plugin
export default {"section":"templates_section__QIIr8"};